import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/cfg-system-settings/footer';

export interface FooterSettings {
    content_footer_logo_text: string | null;
    content_footer_address: string | null;
    content_footer_email: string | null;
    content_footer_phone: string | null;
    content_footer_call_info: string | null;
    content_footer_link_marketplace: string | null;
    content_footer_link_municipio: string | null;
    content_footer_link_bairro_comercial: string | null;
    content_footer_link_privacidade: string | null;
    content_footer_link_cookies: string | null;
    content_footer_social_facebook: string | null;
    content_footer_social_instagram: string | null;
    content_footer_social_youtube: string | null;
    content_footer_social_x: string | null;
    content_footer_social_tiktok: string | null;
    content_footer_funding_logo: string | null;
    content_footer_complaints_book_logo: string | null;
}

export interface GetFooterSuccessResponse {
    data: FooterSettings;
    success: boolean;
    message: string;
}

export const useGetFooter = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const [footer, setFooter] = useState<FooterSettings | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const request = async () => {
        setLoading(true);
        setError(null);

        try {
            const inputParameters = new URLSearchParams(getCommonParameters()).toString();

            const response = await fetch(`${API_URL}${ENDPOINT_URL}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || json.message || 'Erro ao buscar configurações do footer') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const result: GetFooterSuccessResponse = await response.json();

            setFooter(result.data);
        } catch (err: any) {
            handleCommonErrors(err);
            setError(err.message || 'Erro ao buscar configurações do footer');
        } finally {
            setLoading(false);
        }
    };

    return { footer, request, loading, error };
};
